/** @typedef {import('../../lib/types.js').NoteContentBlock} NoteContentBlock */

/** @type {NoteContentBlock[]} */
export const mymanScratchDemoContent = [
  { type: 'heading', level: 1, text: 'Quick scratch — Myman' },
  {
    type: 'paragraph',
    text: 'Call out from design review:',
  },
  {
    type: 'bullets',
    items: [
      'Transcribe button belongs in the meeting card body',
      'Instructions chip stays secondary',
    ],
  },
  {
    type: 'quote',
    text: 'Tagged for follow-up Monday.',
  },
]
